import { requestCheckout } from '@sanjar/checkout';
document.addEventListener('click', async event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-sl-buy-now]');
  if (!button || button.disabled || button.dataset.pending === 'true') return;
  const section = document.getElementById(`shopify-section-${button.dataset.sectionId}`);
  const form = section?.querySelector('.buy-buttons-block product-form-component form');
  const status = button.closest('[ref="stickyBar"], .accelerated-checkout-block')?.querySelector('[data-sl-buy-error]');
  const fail = message => { if (status) { status.textContent = message; status.hidden = false; } };
  if (!form || !form.reportValidity()) { fail(button.dataset.error); return; }
  const data = new FormData(form), variant = data.get('id');
  if (!variant || !/^\d+$/.test(String(variant))) { fail(button.dataset.error); return; }
  const mainButton = form.querySelector('button[type="submit"]');
  if (mainButton?.disabled) { fail(button.dataset.error); return; }
  if (!data.get('quantity')) data.set('quantity', '1');
  data.delete('sections'); data.delete('sections_url');
  button.dataset.pending = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true');
  if (status) status.hidden = true;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || button.dataset.error);
    if (requestCheckout(button, 'product', result)) window.location.assign(`${root}checkout`);
  } catch (error) { fail(error.message || button.dataset.error); }
  finally { if (button.isConnected) { button.disabled = false; button.removeAttribute('aria-busy'); delete button.dataset.pending; } }
}, { capture: true });
